import {Utils} from '../Utils'
import {PokerMap} from '../data/Map'
import {FilterOption} from '../ui/lobby/menu/filter/FilterComponent'
export class Filter {
	constructor() {
	}
	filterUpdated() {
	}
	updateFilter(filterOptions: FilterOption<any>[]){}
	/**
     * Returns true if it should be included in the lobby and
     * false if it shouldn't
     * @param lobbyData
     * @return {boolean} if it should be included
     */
	filter(lobbyData) {
		return false
	}

	reset() {}
}

export class LobbyFilter extends Filter {

	enabled : boolean
	id : any
	filterFunction : any
	checkbox : boolean
	nrOfItems : number
	countDiv : JQuery



	constructor(id, enabled, filterFunction) {
		super()
		var userSetting = Utils.loadBoolean(id, enabled)
		this.enabled = false
		this.id = null
		this.filterFunction = null
		this.checkbox = false
		this.nrOfItems = 0
		this.countDiv = null
		this.enabled = userSetting
		this.id = id
		this.filterFunction = filterFunction

		var self = this
		var input = $('#' + this.id)
		this.countDiv = input.find('.count')
		if (input.attr('type') == 'checkbox') {
			this.checkbox = true
			input.on('change', this.clickHandler(self))
			if (this.enabled == true) {
				input.attr('checked', ''+true)
			} else {
				input.attr('checked', ''+false)
			}
		} else {
			input.touchSafeClick(this.clickHandler(self))
			if (this.enabled == true) {
				$('#' + this.id).addClass('active')
			} else {
				$('#' + this.id).removeClass('active')
			}
		}

	}

	filterUpdated() {
		this.nrOfItems = 0
	}

	/**
     * Returns true if it should be included in the lobby and
     * false if it shouldn't
     * @param lobbyData
     * @return {boolean} if it should be included
     */
	filter(lobbyData) {
		var include = this.filterFunction(this.enabled, lobbyData)

		if (lobbyData.seated && lobbyData.seated > 0) {
			this.nrOfItems++
		}
		return include
	}

	updateCount() {
		if (this.nrOfItems > 0) {
			this.countDiv.html('(' + this.nrOfItems + ')')
		} else {
			this.countDiv.html('')
		}
	}

	clickHandler(self) {
		return function () {
			self.enabled = !self.enabled
			if (self.checkbox == false) {
				$(this).toggleClass('active')
			}
			Utils.store(self.id, self.enabled)
			self.filterUpdated()
		}
	}
}

export class RadioGroupFilter extends Filter {
	/**
     * A list of filters that should be treated as a group of radio buttons.
     * That is, when one of the filters is enabled, all other filters should be
     * disabled.
     */
	radioGroup : any
	properties : any
	currentFilter : any
	idProperty : string
	emptyFilterGroups : any
	autoHideEmpty : boolean
	changeListener : any
	groupCount : any
	showIfInGroup : boolean
	enabled : boolean
    

	constructor(group, properties, prefix, idProperty?, autoHideEmpty?) {
		super()
		var self = this

		this.radioGroup = null
		this.properties = null
		this.currentFilter = null
		this.idProperty = 'id'
		this.emptyFilterGroups = null
		this.autoHideEmpty = true
		this.changeListener = null
		this.groupCount = null
		this.showIfInGroup = false

		if (typeof(autoHideEmpty) !== 'undefined') {
			this.autoHideEmpty = autoHideEmpty
		}
		if (typeof(idProperty) !== 'undefined') {
			this.idProperty = idProperty
		}
		this.radioGroup = group
		this.groupCount = new PokerMap<any>()
		this.properties = properties
		this.currentFilter = group[0][this.idProperty]
		this.reset()
		$.each(group, function (i, el) {
			self.groupCount.put(el[self.idProperty], 0)
		})

	}

	reset() {
		if (this.autoHideEmpty == true) {
			var self = this
			this.emptyFilterGroups = new PokerMap<any>()
			$.each(this.radioGroup, function (i, e) {
				self.emptyFilterGroups.put(e[self.idProperty], e)
				self.groupCount.put(e[self.idProperty], 0)
				e.empty = true
			})
		}

	}

	filter(lobbyData) {
		for (var i = 0; i < this.properties.length; i++) {
			if (this.filterSingle(this.properties[i], lobbyData) == false) {
				return false
			}
		}
		return true
	}

	getCountById(id) {
		return this.groupCount.get(id)
	}

	filterSingle(property, lobbyData) {
		var p = lobbyData[property]

		if (typeof(p) !== 'undefined' && typeof(lobbyData.seated) !== 'undefined' && parseInt(lobbyData.seated) > 0) {
			var count = 1
			if (this.groupCount.contains(p)) {
				count = this.groupCount.get(p) + 1
			}

			this.groupCount.put(p, count)
		}

		if (typeof(p) !== 'undefined' && !this.enabled) {
			$.each(this.radioGroup, function (i, group) {
				if (group.id == p) {
					group.empty = false
				}
			})
			if (this.autoHideEmpty == true) {
				this.emptyFilterGroups.remove(p)
			}
			if (this.showIfInGroup == true) {
				for (var i = 0; i < this.radioGroup.length; i++) {
					if (this.radioGroup[i][this.idProperty] == p) {
						return true
					}
				}
				return false
			} else {
				return (p == this.currentFilter)
			}
		} else {
			return true
		}
	}

	filterUpdated() {

	}

	hideEmptyFilters() {
	}

	getEmptyFilterGroups() {
		return this.emptyFilterGroups.keys()
	}
}



export class PrivateTournamentFilter extends Filter{

	constructor () {
		super()
	}
	filter(lobbyData) {
		var operatorId = 10
		var stringList = lobbyData['operatorIds']
		if (lobbyData['hideLockedTournament'] == true) {
			return false
		} else if (!stringList || stringList.length == 0) {
			return true // this is a table, or no operators set
		} else if (!operatorId) {
			// this is a private tournament, but the player has no operator (?!), deny
			return false
		} else {
			var stringArr = stringList.split(',')
			return $.inArray(operatorId.toString(), stringArr) != -1 // allow if in array
		}
	}
}
